export default "__VITE_ASSET__BOYEBISi__"